export default function NotFound() {
    return (
        <>
            <title>404</title>
            <h1 className="text-center font-bold text-[#FCD3BB] text-[4rem]">404</h1>
            <p className="text-center mb-4">
                That URL doesn't look quite right. You can get back to navigating the site with the <a href="/directory">directory</a>. If you reached this page through any link on the site, please let me know. Thank you for visiting. 💝
            </p>
        </>
    )
}